/* Mother Almanac — page-level interactions
   Vanilla JS port of source/components/hooks.jsx + almanac.jsx + journal.jsx scroll-pin.
   Loaded once on the homepage template. */

(function () {
  'use strict';

  // ─── Reveal-on-scroll (.reveal → .is-in) ───────────────────────────
  function initReveal() {
    var els = document.querySelectorAll('.reveal:not(.is-in)');
    if (!els.length || typeof IntersectionObserver === 'undefined') {
      // Fallback: show everything immediately so nothing stays hidden.
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  // ─── Active section for sticky page-rail (.page-chrome a.is-active) ─
  function initActiveSection() {
    var rail = document.querySelector('.page-chrome');
    if (!rail) return;
    var links = Array.prototype.slice.call(rail.querySelectorAll('a'));
    var ids = links.map(function (a) { return (a.getAttribute('href') || '').replace('#', ''); }).filter(Boolean);
    if (!ids.length) return;

    var darkIds = ['problem', 'farm', 'end', 'journal'];
    var probe = 120;

    function update() {
      var y = window.scrollY + window.innerHeight * 0.4;
      var active = ids[0];
      for (var i = 0; i < ids.length; i++) {
        var el = document.getElementById(ids[i]);
        if (el && el.offsetTop <= y) active = ids[i];
      }
      links.forEach(function (a) {
        a.classList.toggle('is-active', a.getAttribute('href') === '#' + active);
      });

      // page-chrome--on-forest when a dark section is at the probe line
      var dark = false;
      for (var j = 0; j < ids.length; j++) {
        if (darkIds.indexOf(ids[j]) === -1) continue;
        var el2 = document.getElementById(ids[j]);
        if (!el2) continue;
        var r = el2.getBoundingClientRect();
        if (r.top <= probe && r.bottom > probe) { dark = true; break; }
      }
      rail.classList.toggle('page-chrome--on-forest', dark);
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  // ─── Hide page-rail while hero is in view ──────────────────────────
  function initRailHeroHide() {
    var rail = document.querySelector('.page-chrome');
    var hero = document.getElementById('hero');
    if (!rail || !hero || typeof IntersectionObserver === 'undefined') return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        rail.classList.toggle('is-over-hero', e.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(hero);
  }

  // ─── Counter (animated number, IntersectionObserver-triggered) ─────
  function initCounters() {
    var nodes = document.querySelectorAll('[data-counter-end]');
    if (!nodes.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var node = e.target;
        io.unobserve(node);
        var end = parseInt(node.getAttribute('data-counter-end'), 10) || 0;
        var dur = parseInt(node.getAttribute('data-counter-duration'), 10) || 1400;
        var t0 = performance.now();
        function tick(t) {
          var p = Math.min(1, (t - t0) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          node.textContent = Math.round(end * eased);
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.4 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  // ─── FAQ accordion ────────────────────────────────────────────────
  function initFaq() {
    var rows = document.querySelectorAll('.faq-row');
    rows.forEach(function (row, i) {
      var btn = row.querySelector('.faq-q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var alreadyOpen = row.classList.contains('is-open');
        rows.forEach(function (r) { r.classList.remove('is-open'); });
        if (!alreadyOpen) row.classList.add('is-open');
      });
      if (i === 0) row.classList.add('is-open');
    });
  }

  // ─── Specimen Wall (Journal) — desktop scroll-pin ─────────────────
  function initJournal() {
    var section = document.querySelector('.exh-sec:not(.exh-sec--mobile)');
    if (!section) return;
    var stage = section.querySelector('.exh-stage-wrap');
    if (!stage) return;
    var slots = stage.querySelectorAll('.exh-slot');
    if (!slots.length) return;
    var ticks = section.querySelectorAll('.exh-progress__tick');

    var raf = 0;
    function update() {
      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight;
      var scrolled = Math.max(0, -rect.top);
      var progress = Math.min(slots.length, Math.max(0, scrolled / vh));

      var lastIndex = slots.length - 1;
      slots.forEach(function (slot, i) {
        var local = progress - i;
        var opacity = 0;
        var parallaxY = 0;
        var isLast = (i === lastIndex);
        if (local >= -0.7 && local < 0) {
          var t = (local + 0.7) / 0.7;
          opacity = t;
          parallaxY = (1 - t) * 80;
        } else if (local >= 0 && (isLast || local <= 0.4)) {
          if (isLast) {
            opacity = 1;
            parallaxY = 0;
          } else {
            opacity = 1 - (local / 0.4);
            parallaxY = -local * 80;
          }
        }
        opacity = Math.max(0, Math.min(1, opacity));
        slot.style.opacity = opacity;
        slot.style.pointerEvents = opacity > 0.5 ? 'auto' : 'none';
        slot.style.zIndex = Math.round(opacity * 10);
        var spotlight = slot.querySelector('.exh__spotlight');
        var sheet = slot.querySelector('.exh__sheet');
        if (spotlight) spotlight.style.transform = 'translateY(' + (parallaxY * 1.0) + 'px)';
        if (sheet) sheet.style.transform = 'translateY(' + (parallaxY * 0.55) + 'px)';
      });

      ticks.forEach(function (tick, i) {
        var isPast = progress > i + 0.4;
        var isCurrent = !isPast && progress > i - 0.6;
        tick.classList.toggle('is-past', isPast);
        tick.classList.toggle('is-current', isCurrent);
      });
    }

    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () { update(); raf = 0; });
    }
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  // ─── Specimen Wall mobile accordion ───────────────────────────────
  function initJournalMobile() {
    var items = document.querySelectorAll('.exh-stack__item');
    items.forEach(function (item, i) {
      var btn = item.querySelector('.exh-stack__head');
      if (!btn) return;
      btn.addEventListener('click', function () {
        item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
      });
      if (i === 0) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function init() {
    initReveal();
    initActiveSection();
    initRailHeroHide();
    initCounters();
    initFaq();
    initJournal();
    initJournalMobile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
